// extracted by css-extract-rspack-plugin
export default {"content":"content-ck8n4r","spinner":"spinner-MCMj84"};